// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useYearsApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getYears = () => request("GET", `${API_STAGES_URL}/v1/years`)

  return [
    requestState,
    payload,
    error,
    {
      getYears,
    },
  ]
}

export default useYearsApi
